import { BoxV2 as Box, Flex } from 'portal-commons';
import React, { FunctionComponent, ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface DetailsSectionProps {
  title?: string;
  icon?: IconDefinition;
  description?: string;
  testId?: string;
  action?: ReactNode;
}

const DetailsSection: FunctionComponent<DetailsSectionProps> = ({
  title,
  icon,
  description,
  testId,
  action,
  children,
}) => (
  <Box as="section" sx={{ width: '100%' }} data-testid={testId}>
    <Box sx={{ mb: '16px' }}>
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Flex
          sx={{
            alignItems: 'center',
            fontSize: '18px',
            color: 't.black70',
            gap: '8px',
          }}
        >
          {icon && (
            <Box sx={{ color: 't.black80', fontSize: '22px' }}>
              <FontAwesomeIcon icon={icon} />
            </Box>
          )}
          <Box as="h2" sx={{ fontSize: '18px', fontWeight: '600' }}>
            {title}
          </Box>
        </Flex>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Flex>
      {description && (
        <Box
          sx={{
            color: 't.black90',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            mt: title || icon ? '4px' : '0px',
          }}
        >
          {description}
        </Box>
      )}
    </Box>
    <Box
      sx={{
        width: '100%',
        fontWeight: 'semiBold',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default DetailsSection;
